import { render, staticRenderFns } from "./performance-data.vue?vue&type=template&id=39dc546f&scoped=true"
import script from "./performance-data.vue?vue&type=script&lang=js"
export * from "./performance-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dc546f",
  null
  
)

export default component.exports